module.exports = __webpack_public_path__ + "static/img/rechtsanwalt-christoph-schommer.374aeb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rechtsanwalt-christoph-schommer.jpg
// module id = Zwd2
// module chunks = 1